import React from 'react';
import { ArrowRight, Sparkles, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import VideoLoopBackground from './VideoLoopBackground';

const ScellantHero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('scellant-contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('scellant-services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-black">
      {/* Video Background Loop */}
      <VideoLoopBackground />
      
      {/* Dark Overlay - Très foncé */}
      <div className="absolute inset-0 bg-black/80 z-10"></div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-20 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-red-900/30 backdrop-blur-md border border-red-500/30 rounded-full px-6 py-3 mb-8">
            <Sparkles className="text-red-500" size={20} />
            <span className="text-white text-sm font-semibold uppercase tracking-wider">
              Application par pulvérisation professionnelle
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="text-white">Protection. Durabilité.</span>
            <br />
            <span className="bg-gradient-to-r from-red-600 via-red-500 to-red-400 bg-clip-text text-transparent">
              Esthétique impeccable.
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
            Nous utilisons un bitume de haute qualité appliqué par pulvérisation.
            Cette méthode permet au matériau de respirer, de se régénérer et de
            prolonger considérablement sa durée de vie.
          </p>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
            <div className="bg-gray-900/80 backdrop-blur-sm border border-red-500/20 rounded-xl p-6 hover:bg-gray-900 hover:border-red-500/40 transition-all">
              <CheckCircle2 className="text-red-500 mb-3 mx-auto" size={32} />
              <h3 className="text-white font-semibold mb-2">Ravive la couleur</h3>
              <p className="text-gray-400 text-sm">Noir intense et uniforme</p>
            </div>
            <div className="bg-gray-900/80 backdrop-blur-sm border border-red-500/20 rounded-xl p-6 hover:bg-gray-900 hover:border-red-500/40 transition-all">
              <CheckCircle2 className="text-red-500 mb-3 mx-auto" size={32} />
              <h3 className="text-white font-semibold mb-2">Protège durablement</h3>
              <p className="text-gray-400 text-sm">Contre l'usure et intempéries</p>
            </div>
            <div className="bg-gray-900/80 backdrop-blur-sm border border-red-500/20 rounded-xl p-6 hover:bg-gray-900 hover:border-red-500/40 transition-all">
              <CheckCircle2 className="text-red-500 mb-3 mx-auto" size={32} />
              <h3 className="text-white font-semibold mb-2">Prolonge la vie</h3>
              <p className="text-gray-400 text-sm">Durabilité maximale</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 text-white text-lg px-8 py-6 shadow-2xl hover:shadow-red-500/50 transition-all transform hover:scale-105"
            >
              Demander une soumission gratuite
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button
              onClick={scrollToServices}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black text-lg px-8 py-6 backdrop-blur-sm bg-white/10 transition-all transform hover:scale-105"
            >
              Découvrir nos services
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScellantHero;
